import { render, staticRenderFns } from "./FormContent.vue?vue&type=template&id=0bb47aea&scoped=true"
import script from "./FormContent.vue?vue&type=script&lang=js"
export * from "./FormContent.vue?vue&type=script&lang=js"
import style0 from "./FormContent.vue?vue&type=style&index=0&id=0bb47aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb47aea",
  null
  
)

export default component.exports